import type { DragLayerMonitorProps } from '@minoru/react-dnd-treeview';

import { TypeIcon } from './TypeIcon';
import type { CustomData } from './types';

type Props = {
  monitorProps: DragLayerMonitorProps<CustomData>;
};

export const CustomDragPreview = (props: Props) => {
  const item = props.monitorProps.item;

  return (
    <div className="inline-flex items-center h-8 bg-white border border-solid border-darkgray rounded shadow-lg cursor-grabbing pointer-events-none">
      <div className="text-xs w-4 h-4 text-darkgray mx-2">
        <TypeIcon type={item?.data?.type} />
      </div>
      <div className="text-sm text-darkgray mr-2">{item.text}</div>
    </div>
  );
};
